import { render, staticRenderFns } from "./GroupCallRoom.vue?vue&type=template&id=4cf232ac&scoped=true&"
import script from "./GroupCallRoom.vue?vue&type=script&lang=js&"
export * from "./GroupCallRoom.vue?vue&type=script&lang=js&"
import style0 from "./GroupCallRoom.vue?vue&type=style&index=0&id=4cf232ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf232ac",
  null
  
)

export default component.exports